import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'syf-component-library/ui/atoms/Link';
const SamsLink = ({ children, icon, className }) => {
    return (_jsx(Link, { "data-analytics": "clicktrackingevent", "data-object": "link", "data-type": "samsclub.com", "data-cy": "sams-link", href: "https://www.samsclub.com/account/cardholders?xid=account_additional-cardholders", isInline: true, rel: "noopener noreferrer", target: "_blank", icon: icon, className: className, children: children }));
};
export default SamsLink;
